import {useRef , useEffect , useState} from 'react'

const useProgress = () => {
    const [progress, setProgress] = useState(0);
    let timer = useRef(null);
    useEffect(() => {
      let count = 0;
      timer.current = setInterval(() => {
        if (count < 100) {
          count++;
          setProgress(count);
        } else {
          clearInterval(timer);
        }
      }, 10);
  
      return () => {
        clearInterval(timer);
      };
    }, []);
    return progress;
  };
  export default useProgress;
  